<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh
        v-model="isLoading"
        :pulling-text="$t('common.pulling')"
        :loosing-text="$t('common.loosing')"
        :loading-text="$t('common.loading')"
        :success-text="$t('common.refresh_success')"
        @refresh="onRefresh"
      >
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else v-for="(v, key) in list" :key="key" class="item_list">
          <div class="recent">
            <div class="kuaisan-ball left">
              <span class="period-number">{{ v.expect }}{{ $t('common.period_suffix') }}</span>
              <div class="kaijiang">
                <span class="res-des middle">{{ getSizeLabel(v) }}</span>
                <span class="res-des middle">{{ getParityLabel(v) }}</span>
              </div>
            </div>
          </div>
          <div class="topInfo">
            <span>{{ v.status_text }}</span>
            <span>{{ $t('reservation.money') }}: {{ $formatVndAmount(v.money) }}</span>
          </div>
          <div class="topInfo">
            <span>{{ v.win_text }}</span>
            <span>{{ $t('common.amount') }}: {{ $formatVndAmount(v.profit) }}</span>
          </div>
          <div class="topInfo">
            <span>{{ $t('common.task_type') }}</span>
            <span>{{ v.type }}</span>
          </div>
          <div class="time">
            <span>{{ $t('reservation.order_time') }}: {{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t('reservation.settle_time') }}: {{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('my.finish_task'));
        this.isLoading = false;
      }, 500);
    },
    getSizeLabel(v) {
      if (v.status === 0) {
        return 0;
      }
      const sum = v.opencode[0] + v.opencode[1] + v.opencode[2];
      return sum >= 11 && sum <= 18
        ? this.$t('reservation.big')
        : this.$t('reservation.small');
    },
    getParityLabel(v) {
      if (v.status === 0) {
        return 0;
      }
      const sum = v.opencode[0] + v.opencode[1] + v.opencode[2];
      return sum % 2 === 0
        ? this.$t('reservation.double')
        : this.$t('reservation.single');
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head *,
::v-deep .van-loading__text {
  color: #fff;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #29243D;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #342f46;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span,
.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
}

.item_list .topInfo span {
  color: #eb1362cf;
}

.item_list .time span,
.item_list .period-number,
.kuaisan-ball .res-des {
  color: #fff;
}

.item_list .topInfo span:last-child {
  float: right;
}

.item_list .cover {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

.item_list .period-number {
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  justify-content: space-between;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
}

.kuaisan-ball .res-des.middle {
  width: 45%;
  font-size: 35px;
}

.kaijiang {
  display: flex;
  width: 29%;
  flex-direction: row;
  justify-content: space-between;
}
</style>
